import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitEligibility = (data) => api.post("/leads/eligibility", data);
export const submitCallback = (data) => api.post("/leads/callback", data);
export const submitContact = (data) => api.post("/leads/contact", data);
